import AddIcon from '@mui/icons-material/Add';
import { IconButton, Stack, Switch } from '@mui/material';
import { useEffect, useState } from 'react';
import { FaRegEdit } from 'react-icons/fa';
import { getPlacementOriginList, savePlacementOrigin } from 'wisestep-api';
import { WsButton, WsDataTable } from 'wisestep-base';

import { SettingsPageLayout } from '../../../components/SettingsPageLayout';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';
import { useDialog } from '../../../hooks/useDialog';
import { placementSettingsIndexOptions } from '../helper/ClosureHelper';

import PlacementOriginForm from './PlacementOriginForm';

const PlacementOrigin = () => {
  const [openDialog, closeDialog] = useDialog();
  const [flag, setFlag] = useState<boolean>(false);
  const [placementOriginList, setPlacementOriginList] = useState(null);

  const fetchAll = async () => {
    const response = await getPlacementOriginList();
    setPlacementOriginList(response.data);
  };

  useEffect(() => {
    fetchAll();
  }, [flag]);

  const onSave = () => {
    closeDialog();
    setFlag(true);
    fetchAll();
  };

  const openPlacementOriginFormDialog = (defaultValues?) => {
    openDialog({
      children: (
        <PlacementOriginForm
          onSave={onSave}
          onCancel={closeDialog}
          {...(defaultValues && { defaultValues })}
        />
      ),
    });
  };

  const columns = [
    {
      accessor: 'originName',
      Header: 'Placement Origin',
    },
    {
      Header: 'Visibility',
      accessor: 'visibility',
      Cell: (props) => {
        const row = props.row.original;
        return (
          <Switch
            readOnly
            defaultChecked={row.visibility}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              savePlacementOrigin({ ...row, visibility: event.target.checked }).then(fetchAll);
            }}
          />
        );
      },
    },
    {
      Header: 'Is Default Origin',
      accessor: 'isDefaultOrigin',
      Cell: (props) => (props.row.original.isDefaultOrigin ? 'Yes' : 'No'),
    },
    {
      Header: 'Created By',
      accessor: 'createdByName',
    },
    {
      Header: '',
      accessor: 'edit',
      Cell: (props) => {
        const row = props.row.original;
        return (
          <IconButton onClick={() => openPlacementOriginFormDialog(row)}>
            <FaRegEdit />
          </IconButton>
        );
      },
    },
  ];

  return (
    <>
      <>
        <SettingsPageLayout
          title="Placement Origin"
          indexOptions={placementSettingsIndexOptions}
          breadCrumnbsList={getSettingBreadCrumbList(
            ISettingBreadCrumbTypes.PLACEMENTS,
            Pages['PLACEMENT_ORIGIN']
          )}
        >
          <Stack direction="row" p={2} justifyContent="flex-end" alignItems="center">
            <WsButton
              startIcon={<AddIcon />}
              variant="outlined"
              onClick={() => openPlacementOriginFormDialog()}
            >
              Add Placement Origin
            </WsButton>
          </Stack>
          <WsDataTable dense columns={columns} data={placementOriginList ?? []} />
        </SettingsPageLayout>
      </>
    </>
  );
};

export default PlacementOrigin;
